declare namespace $ {

	export class $mol_icon_send extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=send.view.tree.d.ts.map